/*
 * Copyright (c) 2021.
 * Md Naimul Hasan
 * naim886@gmail.com
 * 01719123886
 * www.naimbd.com
 */
import React, {useEffect, useState} from 'react';
import axios from "axios";
import BASEURL from "../../Constants";
import {useHistory} from "react-router-dom";

const Login = () => {

    const history = useHistory();
    useEffect(()=>{
        if (localStorage.admin_token != undefined){
            history.push('/')
        }
    }, [])

    const [errMsg, setErrMsg] =useState({})
    const [inputData, setInputData] = useState({})
    const handleInput = (e) =>{
        let name = e.target.name
        let value = e.target.value
        setInputData(prev=>({...prev, [name]: value}))
    }
    const login = (e) =>{
        e.preventDefault()
        axios.post(BASEURL+'/api/admin/login', inputData).then(res=>{
            localStorage.name = res.data.name
            localStorage.email = res.data.email
            localStorage.admin_token = res.data.token
            history.push('/')
            window.location.reload()
        }).catch(errors=>{
            if(errors.response.status == 422){
                setErrMsg(errors.response.data.errors)
            }
        })
    }

    return (
        <div className={'login-container'}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <div className={'login'}>
                            <div className="card">
                                <div className="card-header">
                                    <h4>Login</h4>
                                </div>
                                <div className="card-body">
                                    <label>
                                        Email :
                                        <input type={'text'}
                                               className={'form-control'}
                                               placeholder={'Insert Email Address'}
                                               name={'email'}
                                               onChange={handleInput}
                                        />
                                        {Object.entries(errMsg).map(([key, val]) => (
                                            <p  key={key}>
                                                <small
                                                    className="text-danger validation-error-message">
                                                    {key == 'email' ? val : ''}
                                                </small>
                                            </p>
                                        ))}
                                    </label>
                                    <label className={'mt-3'}>
                                        Password :
                                        <input type={'password'}
                                               className={'form-control'}
                                               placeholder={'Insert Email Address'}
                                               name={'password'}
                                               onChange={handleInput}
                                        />
                                        {Object.entries(errMsg).map(([key, val]) => (
                                            <p  key={key}>
                                                <small
                                                    className="text-danger validation-error-message">
                                                    {key == 'password' ? val : ''}
                                                </small>
                                            </p>
                                        ))}
                                    </label>
                                    <div className="d-grid">
                                        <button className={'btn btn-success mt-3'} onClick={login} type={'button'}>Login</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;

